import { table } from './_table';
import { form } from './form';

export const worksheets = {
  namespaced: true,
  modules: {
    table,
    form
  }
};
